import React from "react";

import { fontFamily } from "./styles";

const Paper = ({ style, children }) => (
  <div
    style={{
      backgroundColor: "#FFFFFF",
      padding: "2em",
      boxShadow: "0 4px 8px rgba(0, 0, 0, .15)",
      fontFamily,
      ...style
    }}
  >
    {children}
  </div>
);

export default Paper;



// WEBPACK FOOTER //
// ./src/components/analysis/Paper.js